import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import back from "../../assets/back.svg";
import LinkEmpId from "../../components/buttons/linkEmpIdBtn";
import VersionHistoryBtn, {
  AdminButton,
} from "../../components/buttons/versionHistoryBtn";
import DeleteModal from "../../components/modals/deleteModal";
import DeletedPopUp from "../../components/popups/DeletedPopUp";
import { cfaDelete, cfaDetail } from "../../redux/actions/cfaAction";
import ErrorPopup from "../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../components/utilites/loader";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";

const CFADetail = () => {
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const [cfaDeatilData, setCfaDetailData] = useState(null);
  const [delShow, setDelShow] = useState(false);
  const [deletedPop, setDeletedPop] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState(null);
  const user_type = localStorage.getItem("userType");
  useEffect(() => {
    if (user_type === "super_user") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      const permissionValue = permissionData?.find(
        (item) => item?.module_name === "CFA" && item
      );

      setUserData(permissionValue);
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    dispatch(cfaDetail(params.id, onSuccess, onError));
  }, []);
  const onSuccess = (data) => {
    setLoading(false);
    console.log(data.id);
    setCfaDetailData(data.data.data);
  };

  const onError = (err) => {
    setLoading(false);
    console.log(err);
  };
  const delFunc = () => {
    dispatch(cfaDelete(params.id, onDelSuccess, onDelError));
  };

  const onDelSuccess = (data) => {
    console.log(data);
    setDelShow(false);
    setDeletedPop(true);

    const timeOutFnc = () => {
      setDeletedPop(false);
      navigate("/cfa");
    };

    setTimeout(timeOutFnc, 2000);
  };
  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onDelError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };
  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/cfa",
      breadcrumb: " / cfa",
    },

    {
      path: "/cfa/view/:id",
      breadcrumb: cfaDeatilData?.cfa_id
        ? ` / ${cfaDeatilData?.cfa_id} - view`
        : " / view",
    },
  ];
  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });
  return (
    <>
      <div className="products-page">
        <div className="products-main-div">
          <div className="mx-3">
            {breadcrumbs.map(({ match, breadcrumb }) => (
              <NavLink
                key={match.pathname}
                to={match.pathname}
                className="header-route-page fw_400 cursor_pointer"
              >
                <span className="fs_18">{breadcrumb}</span>
              </NavLink>
            ))}
          </div>
          <div
            className="products-main-list my-2 py-1"
            style={{ position: "relative" }}
          >
            <div className="search-container d-flex justify-content-between align-items-center">
              <div
                className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                onClick={() => navigate(-1)}
              >
                <img src={back} alt="back_btn" />
                <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                  BACK
                </span>
              </div>
              <div className=" d-flex justify-content-between m-1 mb-2">
                <VersionHistoryBtn
                  link={`/cfa/version-history-view/${cfaDeatilData?.id}`}
                />
                {(user_type == "super_user" && userData?.write) ||
                user_type == "vendor" ? (
                  <>
                    <AdminButton
                      background="#7065E4"
                      color="white"
                      width="100px"
                      onClick={() => navigate(`/cfa/edit/${cfaDeatilData.id}`)}
                    >
                      <span className="m-2">EDIT</span>
                    </AdminButton>
                    <AdminButton
                      background="#FF6F5B"
                      color="white"
                      width="100px"
                      onClick={() => {
                        setDelShow(true);
                      }}
                    >
                      <span className="m-2">DELETE</span>
                    </AdminButton>
                  </>
                ) : (
                  ""
                )}
                <DeleteModal
                  title={`this CFA - ${cfaDeatilData?.cfa_id}`}
                  show={delShow}
                  handleClose={() => setDelShow(false)}
                  delFunc={delFunc}
                />
              </div>
            </div>
            <div style={{ position: "relative" }}>
              {loading == true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : (
                <div className="  ps-4 ps-lg-4 ms-3 mt-4 col-lg-5 col-md-6 col-10 ">
                  <div className="my-4">
                    <label className=" Neutral_Color fs_14">CFA ID</label>
                    <p className="fs_14">{cfaDeatilData?.cfa_id}</p>
                  </div>
                  <div className="my-4">
                    <label className=" Neutral_Color fs_14">CFA Name</label>
                    <p className="fs_14 text-capitalize">
                      {cfaDeatilData?.cfa_name}
                    </p>
                  </div>
                  <div className="my-4">
                    <label className=" Neutral_Color fs_14">
                      CFA Depot Manager Name
                    </label>
                    <p className="fs_14 text-capitalize">
                      {cfaDeatilData?.cfa_depot_manager}
                    </p>
                  </div>
                  <div className="my-4">
                    <label className=" Neutral_Color fs_14">
                      CFA Email Address
                    </label>
                    <p className="fs_14"> {cfaDeatilData?.email}</p>
                  </div>
                  <div className="my-4">
                    <label className=" Neutral_Color fs_14">
                      CFA Depot Manager Mobile Number
                    </label>
                    <p className="fs_14">{cfaDeatilData?.mobile}</p>
                  </div>
                  <div className="my-4">
                    <label className=" Neutral_Color fs_14">
                      Alternate Mobile Number
                    </label>
                    <p className="fs_14">{cfaDeatilData?.alternate_mobile}</p>
                  </div>
                  <div className="my-4">
                    <label className=" Neutral_Color fs_14">Address</label>
                    <p className="fs_14 col-md-10 col-xxl-6">
                      {`${cfaDeatilData?.address?.address_one}, 
                  ${cfaDeatilData?.address?.address_two}, ${cfaDeatilData?.address?.address_three}`}
                    </p>
                  </div>
                  <div className="my-4">
                    <label className=" Neutral_Color fs_14">Landmark</label>
                    <p className="fs_14">{cfaDeatilData?.address?.landmark}</p>
                  </div>
                  <div className="my-4">
                    <label className=" Neutral_Color fs_14">Pincode</label>
                    <p className="fs_14">{cfaDeatilData?.pincode}</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <DeletedPopUp
          title={`CFA - ${cfaDeatilData?.cfa_id}`}
          show={deletedPop}
        />
        <ErrorPopup
          show={showErrorPopup}
          title={showErrorMsg}
          handleClose={closeErrorPopup}
        />
      </div>
    </>
  );
};

export default CFADetail;
